import { API } from 'aws-amplify';
import { AcronymType } from '../types/AcronymTypes';

const apiName = 'Columbia';

export const getAcronyms = async (startDate: Date | null, endDate: Date | null, state: string = 'new'): Promise<any> => {
  try {
    const response = await API.get(
      apiName,
      `/acronyms?state=${state}&from=${startDate?.toISOString().split('T')[0]}&to=${endDate?.toISOString().split('T')[0]}`,
      null,
    );

    if (response.length >= 0) {
      return {
        data: response,
      };
    } else {
      return {
        errors: ['Something went wrong'],
      };
    }
  } catch (error) {
    console.log(error);
    return {
      errors: ['Something went wrong'],
    };
  }
};

export const updateAcronym = async (name?: string, acronym?: AcronymType): Promise<any> => {
  try {
    const init = {
      method: 'PUT',
      body: acronym,
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
    };
    const response = await API.put(apiName, `/acronyms/${encodeURIComponent(name || '')}`, init);

    if (response) {
      return {
        data: response,
      };
    }
  } catch (error) {
    console.log('error', error);
    return {
      errors: error,
    };
  }
};
